import Inputmask from 'inputmask';

(function () {
    Inputmask()
        .mask(document.getElementsByClassName('input-mask'));
})();
